import React, { useState } from "react";

export default function Addblog({ab}) {
  const [Title, setTitle] = useState("");
  const [link, setlink] = useState("");
  const [Date, setDate] = useState();
  const [Description, setDescription] = useState("");
  const [Image, setImage] = useState("");

  const onchangetitle=(e)=>{
   setTitle( e.target.value)
  }
  const onchangedescription=(e)=>{
    setDescription(e.target.value)
  }
  const onchangelink=(e)=>{
    setlink(e.target.value)
  }
  const onchangedate=(e)=>{
    setDate(e.target.value)
  }

  const onchangeimage=(e)=>{

    const file=(e.target.files[0]);
    console.log(file)
    setImage(file)
  }

  const submit=()=>{
    sendblog();
    
  }

 const sendblog=()=>{
    ab(Title,Description,Date,Image,link);

 }

  return (
    <div>
      Add new blogs
      <div class="mt-4 max-w-md mx-auto bg-white rounded shadow-sm">
        <div class="flex flex-col justify-center">
          <label for="title">Title</label>
          <input
            type="text"
            id="title"
            placeholder="Title"
            value={Title}
            class="w-full border-gray-300 rounded-md shadow-sm"
            onChange={onchangetitle}
          />
          <label for="date">Date</label>
          <input
         
            type="date"
            id="date"
            placeholder="Date"
            value={Date}
            onChange={onchangedate}
            class="w-full border-gray-300 rounded-md shadow-sm mt-2"
          />
          <label for="description">Description</label>
          <input
            type="text"
            id="description"
            placeholder="Description"
            class="w-full border-gray-300 rounded-md shadow-sm mt-2 h-full"
            value={Description}
            onChange={onchangedescription}
          />
          <label for="Link">Link</label>
          <input
            type="text"
            id="Link"
            placeholder="Link"
            class="w-full border-gray-300 rounded-md shadow-sm mt-2 h-full"
            value={link}
            onChange={onchangelink}
          />
          <label for="image">Image</label>
          <input
            type="file"

            id="image"
            onChange={onchangeimage}
            placeholder="Image"
            class="w-full border-gray-300 rounded-md shadow-sm mt-2"
          />

          <button onClick={submit}>add</button>
        </div>
      </div>
    </div>
  );
}
